import { Loading3QuartersOutlined_str } from '@zenlayer/zen-design-icons';
import { useUnmount } from 'ahooks';
import classnames from 'classnames';
import { useContext, useEffect, useRef } from 'react';
import { isNumber } from '../_util/defineType';
import { calc, currency, generateUuid } from '../_util/utils';
import { useConfig } from '../hooks/useConfig';
import SvgIcon from '../svg-icon';
import { AmountGroup, AmountGroupContext } from './group';
import './style/index';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const Amount = props => {
  var _PRICE_UNIT$unit$toLo;
  let {
    del = false,
    prefix,
    loading,
    size,
    color = 'default',
    strong = true,
    unit,
    coefficient = 1,
    independent,
    precision,
    addZero,
    mode,
    value,
    block,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-amount");
  const {
    locale: {
      Amount: AmountLocale
    }
  } = useConfig();
  const idRef = useRef(generateUuid());
  const context = useContext(AmountGroupContext);
  const PRICE_UNIT = {
    month: "/".concat(AmountLocale.month),
    day: "/".concat(AmountLocale.day),
    hour: "/".concat(AmountLocale.hour)
  };
  useEffect(() => {
    var _context$updateAmount;
    (_context$updateAmount = context.updateAmountNumbers) === null || _context$updateAmount === void 0 || _context$updateAmount.call(context, {
      [idRef.current]: !independent && isNumber(value) ? calc.mul(Math.abs(value), coefficient) : undefined
    });
  }, [independent, coefficient, value]);
  useUnmount(() => {
    var _context$removeAmount;
    (_context$removeAmount = context.removeAmountNumber) === null || _context$removeAmount === void 0 || _context$removeAmount.call(context, {
      key: idRef.current
    });
  });
  return /*#__PURE__*/_jsx("span", {
    ...restProps,
    className: classnames(className, baseClassName, "color-".concat(color), {
      del,
      block,
      ["size-".concat(size)]: size,
      strong
    }),
    style: style,
    children: !!loading ? /*#__PURE__*/_jsx(SvgIcon, {
      svgStr: Loading3QuartersOutlined_str,
      spin: true
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [isNumber(value) && value < 0 && /*#__PURE__*/_jsx("span", {
        children: "-"
      }), !!prefix && /*#__PURE__*/_jsx("span", {
        children: prefix
      }), /*#__PURE__*/_jsx("span", {
        children: isNumber(value) ? currency(calc.mul(Math.abs(value), coefficient), independent ? {
          precision,
          addZero,
          mode
        } : context.currencyOptions) : '—'
      }), !!unit && /*#__PURE__*/_jsx("span", {
        children: (_PRICE_UNIT$unit$toLo = PRICE_UNIT[unit.toLowerCase()]) !== null && _PRICE_UNIT$unit$toLo !== void 0 ? _PRICE_UNIT$unit$toLo : unit
      })]
    })
  });
};
Amount.Group = AmountGroup;
export default Amount;